/* Modulo Countdown Split — standalone countdown timer.
   Vanilla IIFE. Server renders the initial numbers (no CLS); this just ticks. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function pad2(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function initSection(el) {
    var endAttr = el.getAttribute('data-end-ms');
    var endMs = endAttr ? parseInt(endAttr, 10) : 0;
    var onComplete = el.getAttribute('data-on-complete') || 'show-message';
    var timer = el.querySelector('[data-modulo-cds-timer]');
    var timerWrap = el.querySelector('[data-modulo-cds-timer-wrap]');
    if (!endMs || !timer) return;

    var daysEl    = timer.querySelector('[data-unit="days"]');
    var hoursEl   = timer.querySelector('[data-unit="hours"]');
    var minutesEl = timer.querySelector('[data-unit="minutes"]');
    var secondsEl = timer.querySelector('[data-unit="seconds"]');
    var interval = null;

    function render(diffMs) {
      var diff = Math.max(0, Math.floor(diffMs / 1000));
      var days = Math.floor(diff / 86400);
      var hrs  = Math.floor((diff % 86400) / 3600);
      var mins = Math.floor((diff % 3600) / 60);
      var secs = diff % 60;
      if (daysEl)    daysEl.textContent    = String(days);
      if (hoursEl)   hoursEl.textContent   = pad2(hrs);
      if (minutesEl) minutesEl.textContent = pad2(mins);
      if (secondsEl) secondsEl.textContent = pad2(secs);
    }

    function complete() {
      el.setAttribute('data-ended', 'true');
      if (onComplete === 'hide-timer' && timerWrap && timerWrap.parentNode) {
        timerWrap.parentNode.removeChild(timerWrap);
      } else if (onComplete === 'hide-section' && el.parentNode) {
        el.parentNode.removeChild(el);
      }
      // show-message handled by CSS via [data-ended="true"]
    }

    var initial = endMs - Date.now();
    if (initial <= 0) { render(0); complete(); return; }
    render(initial);
    interval = setInterval(function () {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        render(0);
        clearInterval(interval);
        interval = null;
        complete();
        return;
      }
      render(diff);
    }, 1000);
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-cds]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
